/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import propTypes from 'prop-types';
import classnames from 'classnames';
import { Transition } from 'react-transition-group';
import { utcToPtDateString } from 'lib/date';

import { MESSAGE_DISPLAY_TIME, TRANSITION_TIME } from '../const';

import styles from './Notifications.css';

/**
 * renders a notification to alert the user
 */
export default class Notifications extends Component {
  static propTypes = {
    message: propTypes.string.isRequired,
    classification: propTypes.string.isRequired,
    date: propTypes.number
  };

  static defaultProps = {
    date: 0
  };

  constructor(props) {
    super(props);

    this.state = {
      displayMessage: props.message,
      messageDate: props.date,
      show: false,
      warningMessage: '',
      warningShown: false
    };

    this.hideNotification = this.hideNotification.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.classification === 'failure' && nextProps.classification === 'success') {
      this.setState(
        {
          displayMessage: nextProps.message,
          messageDate: nextProps.date,
          warningMessage: this.props.message,
          warningShown: true
        },
        this.displayModal
      );
    } else {
      this.setState(
        {
          displayMessage: nextProps.message,
          messageDate: nextProps.date
        },
        this.displayModal
      );
    }
  }

  /**
   * set component state to show the nofication with a timeout to hide
   */
  displayModal() {
    this.setState({ show: true });
    this.fadeOut();
  }

  /**
   * set component state to hide the notification without timeout
   */
  hideNotification() {
    this.setState({
      displayMessage: '',
      show: false,
      warningMessage: '',
      warningShown: false
    });
  }

  /**
   * set component state to hide notification after a set amount of time
   * then clear out the message after the transition has occured
   */
  fadeOut() {
    setTimeout(() => {
      this.setState({
        show: false,
        warningShown: false
      });
    }, MESSAGE_DISPLAY_TIME);

    setTimeout(() => {
      this.setState({
        displayMessage: '',
        warningMessage: ''
      });
    }, MESSAGE_DISPLAY_TIME + TRANSITION_TIME);
  }

  render() {
    const { classification } = this.props;
    const { show, displayMessage, messageDate, warningShown, warningMessage } = this.state;

    const bar = show ? styles.notificationShown : styles.notificationHidden;

    const renderStyle = {
      alert: styles.alert,
      failure: styles.failure,
      success: styles.success
    };

    const renderStyleB = {
      alert: styles.alert,
      failure: styles.alert,
      success: styles.success
    };

    const date = utcToPtDateString(messageDate, 'hh:mm:ss a');

    if (warningShown) {
      return (
        <React.Fragment>
          <Transition in={show} timeout={TRANSITION_TIME}>
            <div className={classnames(styles.wrapper, bar)}>
              <div className={classnames(styles.inner, renderStyle[classification])}>
                <span data-test-id={`notification-${classification}`}>{displayMessage}</span>
                <div
                  data-test-id="notification-close"
                  className={styles.hideNotification}
                  onClick={this.hideNotification}
                >
                  &times;
                </div>
                <div className={styles.date}>{date}</div>
              </div>
            </div>
          </Transition>
          <Transition timeout={TRANSITION_TIME}>
            <div className={classnames(styles.wrapperWarning, bar)}>
              <div className={classnames(styles.inner, styles.failure)}>
                <span data-test-id={`notification-${classification}`}>{warningMessage}</span>
              </div>
            </div>
          </Transition>
        </React.Fragment>
      );
    } else if (displayMessage && !warningShown) {
      return (
        <Transition in={show} timeout={TRANSITION_TIME}>
          <div className={classnames(styles.wrapper, bar)}>
            <div className={classnames(styles.inner, renderStyleB[classification])}>
              <span data-test-id={`notification-${classification}`}>{displayMessage}</span>
              <div
                data-test-id="notification-close"
                className={styles.hideNotification}
                onClick={this.hideNotification}
              >
                &times;
              </div>
              <div className={styles.date}>{date}</div>
            </div>
          </div>
        </Transition>
      );
    }
    return null;
  }
}
